exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-container{background:hsla(0,0%,100%,.2)}.preview-container:hover{background:hsla(0,0%,100%,.5)}.preview-img{max-height:160px;min-height:160px}td:first-child{width:1em;padding:0}td:first-child label{padding:.9rem}td:first-child .form-check{margin:0}.admin td:nth-child(2){width:130px}.admin td:nth-child(3){max-width:280px;text-overflow:ellipsis;overflow:hidden}.admin td:last-child{width:70px}.user td:nth-child(2){width:90px}.pagination li,.table-component__table__caption,li.disabled{display:none}.pagination li.page-item{display:list-item}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76ba88fa","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/printables/index.vue
// module id = 6PB9
// module chunks = 1